// @TODO: also on web, accordion content does not grow to fill list item
// @TODO: the join ui could be prettier
/**
 * Ryan O'Dowd
 * 2022-08-11
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  GOAL_ROUTE,
  fetchMyClassroomsStudent,
  joinClassroom,
  setActiveGoalId,
} from '@utils/store/actions';
import React, {
  useEffect,
  useState,
} from 'react';
import Accordion from '@components/common/Accordion';
import Button from '@components/common/Button';
import EmptyScreen from '@components/common/EmptyScreen';
import Header from '@components/Header';
import {
  KeyboardAwareScrollView,
} from 'react-native-keyboard-controller';
import ListItem from '@components/ListItem';
import ScreenWrapper from '@containers/ScreenWrapper';
import Text from '@components/common/Text';
import TextInput from '@components/common/TextInput';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const CODE_LENGTH = 7;

const Groups = () => {
  const dispatch = hooks.useTypedDispatch();
  const i18n = hooks.useI18n();
  const navigation = hooks.useNavigation();
  const styles = hooks.useStyles(getStyles);

  const goalsByClassroomIds = hooks.useTypedSelector((state) => {
    return Object.values(state.goals).reduce((acc, goal: any) => {
      if (!goal.classroom_goal_metadata.classroom_id) {
        return acc;
      }

      if (!acc[goal.classroom_goal_metadata.classroom_id]) {
        acc[goal.classroom_goal_metadata.classroom_id] = [];
      }
      acc[goal.classroom_goal_metadata.classroom_id].push(goal);

      return acc;
    }, {});
  }, (old, curr) => JSON.stringify(old) === JSON.stringify(curr));

  const [_invitationCodeText, setInvitationCodeText] = useState('');
  const [_joinMessage, setJoinMessage] = useState('');
  const [_joinIsError, setJoinIsError] = useState(false);

  hooks.useBackButton(() => {
    navigation.goBack();
    return true;
  });

  // @TODO: const user = hooks.useTypedSelector((state) => state.oakUser);

  const backIcon = <Header.BackIcon />;

  useEffect(() => {
    dispatch(fetchMyClassroomsStudent());
  }, [dispatch]);

  const myClassrooms = hooks.useTypedSelector((state) => Object.values(state.classrooms), (old, curr) => JSON.stringify(old) === JSON.stringify(curr));

  return (
    <ScreenWrapper>
      <Header
        textColor={styles.colors.white}
        leftItems={[backIcon]}
        title='Groups'
      />
      <KeyboardAwareScrollView
        contentContainerStyle={styles.list}
        style={styles.innerContainer}
        bottomOffset={32}
      >
        {/* @TODO:
        <Text style={styles.TODO}>TODO: pending invites (accept/reject)</Text>
        <Text style={styles.TODO}>TODO: requested invites (show pending status...waiting on teacher approval)</Text>
        */}
        {!!myClassrooms.length &&
          <View style={styles.classroomsWrapper}>
            <Text style={styles.classroomsTitleText}>{i18n('myClassrooms')}</Text>
            {myClassrooms.map((classroom: any) => {
              return (
                <Accordion
                  key={classroom.id}
                  title={
                    <View style={styles.classroomListItem}>
                      <Text style={styles.classroomName}>{classroom.name}</Text>
                      <Text style={styles.schoolName}>{classroom.school.name}</Text>{/* @TODO: put only for schools, not churches: , <Text style={styles.teacherName}>{classroom.teacher.display_name}</Text></Text> */}
                    </View>
                  }
                >
                  {!goalsByClassroomIds[classroom.id]?.length &&
                    <EmptyScreen.Wrapper>
                      <EmptyScreen.Text extraStyle={styles.emptyGoalsText}>
                        You have successfully joined {classroom.name}. Goals will show up here after they have been assigned.
                      </EmptyScreen.Text>
                    </EmptyScreen.Wrapper>
                  }
                  {goalsByClassroomIds[classroom.id]?.map((goal) => {
                    return (
                      <ListItem
                        key={goal.id}
                        innerStyles={[styles.classroomListItem, !goal.user_goal && styles.draftOrUnassignedListItem]}
                        hasBadge={!goal.user_goal || goal.classroom_goal_metadata.status === 'draft'}
                        badgeText={goal.classroom_goal_metadata.status === 'draft' ? i18n('draft') : (!goal.user_goal ? i18n('unassigned') : undefined)}
                        badgeTextSize={styles.globalScale * 22}
                        onPress={() => {
                          dispatch(setActiveGoalId(goal.id));
                          navigation.navigate(GOAL_ROUTE);
                        }}
                        variant='primary'
                      >
                        {/* @TODO: progress indicator */}
                        <Text style={styles.goalName}>{goal.title}</Text>
                      </ListItem>
                    );
                  })}
                </Accordion>
              );
            })}
          </View>
        }

        <View style={styles.joinWrapperOuter}>
          <Text style={styles.instructionsText}>{i18n('toJoinAClassroom')}</Text>

          <View style={styles.joinWrapper}>
            <View style={styles.textInputWrapper}>
              <TextInput
                style={styles.titleTextInput}
                maxLength={CODE_LENGTH}
                numberOfLines={1}
                textColor={styles.colors.white}
                autoCapitalize='characters'
                autoCorrect={false}
                onChangeText={(invitationCodeText) => setInvitationCodeText(invitationCodeText.toUpperCase())}
                value={_invitationCodeText}
                mode='outlined'
                outlineColor={styles.colors.primaryExtraDark}
                activeOutlineColor={styles.colors.accent}
                placeholder={i18n('code')}
              />
            </View>
            <Button
              theme={styles.colors.accent}
              disabled={_invitationCodeText.length < CODE_LENGTH}
              onPress={() => {
                // save to back end
                dispatch(joinClassroom(_invitationCodeText, (isError, message) => {
                  if (!isError) {
                    setInvitationCodeText('');

                    // fetch goals/wrinkles to include data for goals in this classroom // @TODO: right now adding goals is manually done by teacher after the student is in the classroom, so this isn't necessary right now
                    // @TODO: dispatch(fetchGoals());
                    // @TODO: dispatch(fetchWrinkles());
                  }
                  setJoinIsError(isError);
                  setJoinMessage(message);
                }));
              }}
            >
              {i18n('joinClassroom')}
            </Button>
          </View>
          <View style={styles.messageWrapper}>
            <Text style={[styles.joinMessage, _joinIsError && styles.errorText]}>{_joinMessage}</Text>
          </View>
        </View>

        {/* @TODO:
        <Text style={styles.TODO}>TODO: qr scanner for new codes (v2 probably...only show if device has camera...not a desktop)</Text>
        */}
      </KeyboardAwareScrollView>
    </ScreenWrapper>
  );
};

export default Groups;
